import React from "react"; // eslint-disable-line
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route, Switch } from "react-router-dom";
import moment from "moment-timezone";

import _actions from "../../actions";
import GeneralInfo from "../appSettings/GeneralInfo";
import Logo from "../appSettings/logo";
import Integrations from "../appSettings/integrations";
import EnableModules from "../modules/EnableModules";
import Giving from "../modules/GivingModule";
import Sermons from "../modules/SermonsModule";
import Events from "../modules/EventsModule";
import Discover from "../modules/DiscoverModule";
import Contact from "../modules/ContactModule";
import Calendar from "../modules/CalendarModule";
import Pages from "../pages/PagesModule";
import People from "../modules/PeopleModule";
import Groups from "../modules/GroupsModule";
import Colors from "../design/colors";
import Results from "../status/Results";
import "../../assets/styles/master.css";
import ConfigureMenu from "../design/menu";
import constants from "../../constants";
import Catch404 from "../pages/Catch404";
import FormsModule from "../modules/FormsModule";
import appStateProvider from "../../utilities/appStateProvider";
import ServicePlanning from "../modules/ServicePlanningModule";
import StudioC from "../modules/StudioCModule";
import Attendance from "../modules/AttendanceModule";
import MassContact from "../modules/MassContactModule";

class VersionViews extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fmsStandaloneAccess: false };
  }

  //this function was created while working on the massContact module, but can be expand to also use in other modules in future.
  renderConditionalRoute = (requiredFlags, path, component) => {
    const { flags, match } = this.props;
    const fullPath = `modules/${path}`;//This can be changed based if used in other areas like pages or other screen which  not have route modules

    if (!flags.results) return null;
    
    const isFeatureSatisfied = requiredFlags.every(flag => flags.results[flag]);
    
    return isFeatureSatisfied ? (
      <Route
        exact
        path={`${match.path}${fullPath}`}
        component={component}
      />
    ) : null;
  };

  withChMSRequiredFlags = (flags) => {
    return ['chMSIntegration', ...flags];
  };

  componentDidMount() {
    if (this.props.projects.data.length === 0) {
      this.props.actions.getProjects();
    }

    if (appStateProvider().isStandalone()) {
      this.setState({ fmsStandaloneAccess: true });
    }
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          flex: "1",
        }}
      >
        <div className="main">
          <Switch>
            <Route
              exact
              path={`${this.props.match.path}`}
              component={
                this.props.match.params.projectId.length === 36
                  ? GeneralInfo
                  : Catch404
              }
            />
            <Route
              exact
              path={`${this.props.match.path}general-info`}
              component={GeneralInfo}
            />
            <Route
              exact
              path={`${this.props.match.path}logos`}
              component={Logo}
            />
            {this.props.flags.results
              ? (this.props.flags.results?.liveStreaming ||
                  this.props.flags.results?.chMSIntegration ||
                  this.props.flags.results?.shareFaithDevotionals) && (
                  <Route
                    exact
                    path={`${this.props.match.path}integrations`}
                    component={Integrations}
                  />
                )
              : ""}

            <Route
              exact
              path={`${this.props.match.path}modules/enable-modules`}
              component={EnableModules}
            />
            <Route
              exact
              path={`${this.props.match.path}modules/giving`}
              component={Giving}
            />
            <Route
              exact
              path={`${this.props.match.path}modules/sermons`}
              component={Sermons}
            />
            <Route
              exact
              path={`${this.props.match.path}modules/events`}
              component={Events}
            />
            <Route
              exact
              path={`${this.props.match.path}modules/discover`}
              component={Discover}
            />
            <Route
              exact
              path={`${this.props.match.path}modules/discover/:section`}
              component={Discover}
            />
            <Route
              exact
              path={`${this.props.match.path}modules/contact`}
              component={Contact}
            />
            {this.props.flags.results 
              ? this.props.flags.results?.servicePlanning && (
                <Route 
                  exact 
                  path={`${this.props.match.path}modules/service-planning`} 
                  component={ServicePlanning} />
                ) 
              : "" 
            }
            {this.props.flags.results
              ? this.props.flags.results?.calendar && (
                  <Route
                    exact
                    path={`${this.props.match.path}modules/calendar`}
                    component={Calendar}
                  />
                )
              : ""}
            {this.props.flags.results
              ? this.props.flags.results?.chMSIntegration &&
                this.props.flags.results?.scPeople && (
                  <Route
                    exact
                    path={`${this.props.match.path}modules/people`}
                    component={People}
                  />
                )
              : ""}
            {this.props.flags.results
              ? this.props.flags.results?.chMSIntegration &&
                this.props.flags.results?.scGroups && (
                  <Route
                    exact
                    path={`${this.props.match.path}modules/groups`}
                    component={Groups}
                  />
                )
              : ""}
              {this.props.flags.results
              ? this.props.flags.results?.chMSIntegration &&
                this.props.flags.results?.studioC && (
                  <Route
                    exact
                    path={`${this.props.match.path}modules/studioc`}
                    component={StudioC}
                  />
                )
              : ""}
              {this.props.flags.results
              ? this.props.flags.results?.chMSIntegration &&
                this.props.flags.results?.attendance && (
                  <Route
                    exact
                    path={`${this.props.match.path}modules/attendance`}
                    component={Attendance}
                  />
                )
              : ""}
            {this.renderConditionalRoute(this.withChMSRequiredFlags(['massContact']), 'mass-contact', MassContact)}                          
            {this.props.flags.results
              ? this.props.flags.results?.customContent &&
                this.props.flags.results?.customContentPages && (
                  <Route
                    exact
                    path={`${this.props.match.path}pages/pages`}
                    component={Pages}
                  />
                )
              : ""}
            {this.props.flags.results
              ? this.props.flags.results?.customContent &&
                this.props.flags.results?.customContentPages && (
                  <Route
                    exact
                    path={`${this.props.match.path}pages/pages/:pageId`}
                    component={Pages}
                  />
                )
              : ""}
            <Route
              exact
              path={`${this.props.match.path}design/colors`}
              component={Colors}
            />
            <Route
              exact
              path={`${this.props.match.path}design/menus`}
              component={ConfigureMenu}
            />
            <Route
              exact
              path={`${this.props.match.path}forms/home`}
              component={
                this.state.fmsStandaloneAccess ? FormsModule : GeneralInfo
              }
            />
            <Route
              exact
              path={`${this.props.match.path}submission/results`}
              component={Results}
            />
            {this.props.flags.results && <Route component={Catch404} />}
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(_actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VersionViews);
